module.exports = {
	"contractName": "Dragon",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "dragonTail",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "dragonDen",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "dragonWings",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "dragonHead",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				},
				{
					"name": "_dragonDen",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "complete",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "attackHead",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_address",
					"type": "address"
				}
			],
			"name": "attackWings",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_secrect",
					"type": "bytes"
				}
			],
			"name": "attackTail",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "changeDragonDen",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "26:1245:5:-;;;178:174;8:9:-1;5:2;;;30:1;27;20:12;5:2;178:174:5;;;;;;;;;;;;;;;;;;;245:5;232:18;;;305:14;;-1:-1:-1;;;;;;305:14:5;-1:-1:-1;;;;;305:14:5;;;;;;-1:-1:-1;;;;;;325:22:5;;;;;;;;;;;;;26:1245;;;;;;;;",
	"deployedSourceMap": "26:1245:5:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;46:22;;8:9:-1;5:2;;;30:1;27;20:12;5:2;46:22:5;;;;;;;;;;;;;;;;;;;;;;461:92;;8:9:-1;5:2;;;30:1;27;20:12;5:2;461:92:5;;;;;;1113:155;;;;356:101;;8:9:-1;5:2;;;30:1;27;20:12;5:2;356:101:5;;;;125:24;;8:9:-1;5:2;;;30:1;27;20:12;5:2;125:24:5;;;;;;;;-1:-1:-1;;;;;125:24:5;;;;;;;;;;;;;;153:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;153:20:5;;;;72:23;;8:9:-1;5:2;;;30:1;27;20:12;5:2;72:23:5;;;;99:22;;8:9:-1;5:2;;;30:1;27;20:12;5:2;99:22:5;;;;557:420;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;557:420:5;;;-1:-1:-1;;;;;557:420:5;;;981:128;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;981:128:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;981:128:5;;-1:-1:-1;981:128:5;;-1:-1:-1;;;;;;;981:128:5;46:22;;;;;;:::o;461:92::-;518:5;;-1:-1:-1;;;;;518:5:5;504:10;:19;496:28;;;;;;531:10;:17;;-1:-1:-1;;531:17:5;;;;;461:92::o;1113:155::-;1200:11;1182:10;1169:9;:23;1161:32;;;;;;-1:-1:-1;1214:5:5;;;;1233:9;;-1:-1:-1;;;;;1233:9:5;;;;;;-1:-1:-1;;1225:17:5;;;;;;-1:-1:-1;;1248:15:5;;;1214:5;;1248:15;;;;;;1113:155::o;356:101::-;392:4;412:10;;;;:25;;;;-1:-1:-1;426:11:5;;;;;;;412:25;:39;;;;-1:-1:-1;441:10:5;;;;;;;412:39;404:48;;356:101;:::o;125:24::-;;;;;;-1:-1:-1;;;;;125:24:5;;:::o;153:20::-;;;-1:-1:-1;;;;;153:20:5;;:::o;72:23::-;;;;;;;;;:::o;99:22::-;;;;;;;;;:::o;557:420::-;647:12;;;;-1:-1:-1;;;;;617:22:5;;:10;:22;609:31;;;;;;-1:-1:-1;;;662:17:5;;;;-1:-1:-1;685:63:5;754:60;838:1;821:151;845:2;841:1;:6;821:151;;;881:7;866:22;;;873:4;866;:11;:22;;;;862:65;;;900:11;:18;;-1:-1:-1;;900:18:5;;;;;862:65;934:10;-1:-1:-1;;952:13:5;;;;;;934:10;;;;;;;;849:3;;821:151;;;557:420;;;;;:::o;981:128::-;1070:9;;1046:19;;;;1070:9;;;;-1:-1:-1;;;;;1070:9:5;;1046:19;;;;;;;;;;;;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;299:10;344;;263:2;259:12;;;;254:3;250:22;-1:-1;;246:30;311:9;;295:26;;;340:21;;377:20;;;;365:33;;1046:19:5;;;;;;;;;;-1:-1:-1;;;;;1038:41:5;;;;;;-1:-1:-1;1030:50:5;;-1:-1:-1;;1030:50:5;;;;;-1:-1:-1;1087:10:5;:17;;-1:-1:-1;;1087:17:5;1100:4;1087:17;;;981:128::o",
	"source": "pragma solidity ^0.4.18;\n\ncontract Dragon {\n  bool public dragonTail;\n  bool public dragonWings;\n  bool public dragonHead;\n  address public dragonDen;\n  address public owner;\n\n  constructor(address _owner, address _dragonDen) {\n    dragonTail = false;\n    dragonWings = false;\n    dragonHead = false;\n    owner = _owner;\n    dragonDen = _dragonDen;\n  }\n\n  function complete() public returns (bool) {\n    return (dragonTail && dragonWings && dragonHead);\n  }\n\n  function attackHead() public {\n    require(msg.sender == owner);\n\n    dragonHead = true;\n  }\n\n  function attackWings(address _address) public {\n    require(msg.sender == _address);\n\n    bytes20 addr = bytes20(_address);\n    bytes20 ftBlood = hex\"00000000000000000000000000000000042b100d\";\n    bytes20 mask = hex\"000000000000000000000000000000000fffffff\";\n\n    for (uint256 i = 0; i < 34; i++) {\n      if (addr & mask == ftBlood) {\n        dragonWings = true;\n      }\n      mask <<= 4;\n      ftBlood <<= 4;\n    }\n\n  }\n\n  function attackTail(bytes _secrect) public {\n    require(address(keccak256(_secrect)) == dragonDen);\n\n    dragonTail = true;\n  }\n\n  function changeDragonDen() public payable {\n    require(msg.value == 0.42 ether);\n\n    address tmp = owner;\n    owner = dragonDen;\n    dragonDen = tmp;\n  }\n\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Dragon.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Dragon.sol",
		"exportedSymbols": {
			"Dragon": [
				777
			]
		},
		"id": 778,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 609,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:5"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 777,
				"linearizedBaseContracts": [
					777
				],
				"name": "Dragon",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 611,
						"name": "dragonTail",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "46:22:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 610,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "46:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 613,
						"name": "dragonWings",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "72:23:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 612,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "72:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 615,
						"name": "dragonHead",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "99:22:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 614,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "99:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 617,
						"name": "dragonDen",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "125:24:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 616,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "125:7:5",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 619,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "153:20:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 618,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "153:7:5",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 646,
							"nodeType": "Block",
							"src": "226:126:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 628,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 626,
											"name": "dragonTail",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 611,
											"src": "232:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 627,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "245:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "232:18:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 629,
									"nodeType": "ExpressionStatement",
									"src": "232:18:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 632,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 630,
											"name": "dragonWings",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 613,
											"src": "256:11:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 631,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "270:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "256:19:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 633,
									"nodeType": "ExpressionStatement",
									"src": "256:19:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 636,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 634,
											"name": "dragonHead",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 615,
											"src": "281:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 635,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "294:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "281:18:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 637,
									"nodeType": "ExpressionStatement",
									"src": "281:18:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 640,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 638,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 619,
											"src": "305:5:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 639,
											"name": "_owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 621,
											"src": "313:6:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "305:14:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 641,
									"nodeType": "ExpressionStatement",
									"src": "305:14:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 644,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 642,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "325:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 643,
											"name": "_dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 623,
											"src": "337:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "325:22:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 645,
									"nodeType": "ExpressionStatement",
									"src": "325:22:5"
								}
							]
						},
						"documentation": null,
						"id": 647,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 624,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 621,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 647,
									"src": "190:14:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 620,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "190:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 623,
									"name": "_dragonDen",
									"nodeType": "VariableDeclaration",
									"scope": 647,
									"src": "206:18:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 622,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "206:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "189:36:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 625,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "226:0:5"
						},
						"scope": 777,
						"src": "178:174:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 659,
							"nodeType": "Block",
							"src": "398:59:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 656,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 654,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 652,
														"name": "dragonTail",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 611,
														"src": "412:10:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 653,
														"name": "dragonWings",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 613,
														"src": "426:11:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "412:25:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 655,
													"name": "dragonHead",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 615,
													"src": "441:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "412:39:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"id": 657,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "411:41:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 651,
									"id": 658,
									"nodeType": "Return",
									"src": "404:48:5"
								}
							]
						},
						"documentation": null,
						"id": 660,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "complete",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 648,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "373:2:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 651,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 650,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 660,
									"src": "392:4:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 649,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "392:4:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "391:6:5"
						},
						"scope": 777,
						"src": "356:101:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 674,
							"nodeType": "Block",
							"src": "490:63:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 667,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 664,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "504:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 665,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "504:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 666,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 619,
													"src": "518:5:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "504:19:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 663,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "496:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 668,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "496:28:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 669,
									"nodeType": "ExpressionStatement",
									"src": "496:28:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 672,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 670,
											"name": "dragonHead",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 615,
											"src": "531:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 671,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "544:4:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "531:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 673,
									"nodeType": "ExpressionStatement",
									"src": "531:17:5"
								}
							]
						},
						"documentation": null,
						"id": 675,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackHead",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 661,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "480:2:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 662,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "490:0:5"
						},
						"scope": 777,
						"src": "461:92:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 732,
							"nodeType": "Block",
							"src": "603:374:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 684,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 681,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "617:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 682,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "617:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 683,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 677,
													"src": "631:8:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "617:22:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 680,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "609:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 685,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "609:31:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 686,
									"nodeType": "ExpressionStatement",
									"src": "609:31:5"
								},
								{
									"assignments": [
										688
									],
									"declarations": [
										{
											"constant": false,
											"id": 688,
											"name": "addr",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "647:12:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 687,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "647:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 692,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 690,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 677,
												"src": "670:8:5",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 689,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "662:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes20_$",
												"typeString": "type(bytes20)"
											},
											"typeName": "bytes20"
										},
										"id": 691,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "662:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes20",
											"typeString": "bytes20"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "647:32:5"
								},
								{
									"assignments": [
										694
									],
									"declarations": [
										{
											"constant": false,
											"id": 694,
											"name": "ftBlood",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "685:15:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 693,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "685:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 696,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "00000000000000000000000000000000042b100d",
										"id": 695,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "703:45:5",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_182bb3fec0beccb0a6ed9760bb9b85e822212cadb96c14aa54c4df47cb8d9bf6",
											"typeString": "literal_string \"\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0004+\u0010\r\""
										},
										"value": "\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0004+\u0010\r"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "685:63:5"
								},
								{
									"assignments": [
										698
									],
									"declarations": [
										{
											"constant": false,
											"id": 698,
											"name": "mask",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "754:12:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 697,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "754:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 700,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "000000000000000000000000000000000fffffff",
										"id": 699,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "769:45:5",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_04be31e00e47e621a6f132c63a563fa1b96fc809d569bf050c86d8cff4f8101f",
											"typeString": "literal_string (contains invalid UTF-8 sequence at position 17)"
										},
										"value": null
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "754:60:5"
								},
								{
									"body": {
										"id": 730,
										"nodeType": "Block",
										"src": "854:118:5",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													},
													"id": 715,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														},
														"id": 713,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 711,
															"name": "addr",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 688,
															"src": "866:4:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes20",
																"typeString": "bytes20"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 712,
															"name": "mask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 698,
															"src": "873:4:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes20",
																"typeString": "bytes20"
															}
														},
														"src": "866:11:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 714,
														"name": "ftBlood",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 694,
														"src": "881:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"src": "866:22:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 721,
												"nodeType": "IfStatement",
												"src": "862:65:5",
												"trueBody": {
													"id": 720,
													"nodeType": "Block",
													"src": "890:37:5",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 718,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 716,
																	"name": "dragonWings",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 613,
																	"src": "900:11:5",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 717,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "914:4:5",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "900:18:5",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 719,
															"nodeType": "ExpressionStatement",
															"src": "900:18:5"
														}
													]
												}
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 724,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 722,
														"name": "mask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 698,
														"src": "934:4:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "Assignment",
													"operator": "<<=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "34",
														"id": 723,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "943:1:5",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_4_by_1",
															"typeString": "int_const 4"
														},
														"value": "4"
													},
													"src": "934:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													}
												},
												"id": 725,
												"nodeType": "ExpressionStatement",
												"src": "934:10:5"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 728,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 726,
														"name": "ftBlood",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 694,
														"src": "952:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "Assignment",
													"operator": "<<=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "34",
														"id": 727,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "964:1:5",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_4_by_1",
															"typeString": "int_const 4"
														},
														"value": "4"
													},
													"src": "952:13:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													}
												},
												"id": 729,
												"nodeType": "ExpressionStatement",
												"src": "952:13:5"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 705,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 702,
											"src": "841:1:5",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3334",
											"id": 706,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "845:2:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_34_by_1",
												"typeString": "int_const 34"
											},
											"value": "34"
										},
										"src": "841:6:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 731,
									"initializationExpression": {
										"assignments": [
											702
										],
										"declarations": [
											{
												"constant": false,
												"id": 702,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 733,
												"src": "826:9:5",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 701,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "826:7:5",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 704,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 703,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "838:1:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "826:13:5"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 709,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "849:3:5",
											"subExpression": {
												"argumentTypes": null,
												"id": 708,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 702,
												"src": "849:1:5",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 710,
										"nodeType": "ExpressionStatement",
										"src": "849:3:5"
									},
									"nodeType": "ForStatement",
									"src": "821:151:5"
								}
							]
						},
						"documentation": null,
						"id": 733,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackWings",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 678,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 677,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 733,
									"src": "578:16:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 676,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "578:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "577:18:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 679,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "603:0:5"
						},
						"scope": 777,
						"src": "557:420:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 752,
							"nodeType": "Block",
							"src": "1024:85:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 745,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 741,
																	"name": "_secrect",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 735,
																	"src": "1056:8:5",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes_memory_ptr",
																		"typeString": "bytes memory"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes_memory_ptr",
																		"typeString": "bytes memory"
																	}
																],
																"id": 740,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "1046:9:5",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 742,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "1046:19:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 739,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "1038:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 743,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1038:28:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 744,
													"name": "dragonDen",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 617,
													"src": "1070:9:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1038:41:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 738,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1030:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 746,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1030:50:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 747,
									"nodeType": "ExpressionStatement",
									"src": "1030:50:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 750,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 748,
											"name": "dragonTail",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 611,
											"src": "1087:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 749,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1100:4:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "1087:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 751,
									"nodeType": "ExpressionStatement",
									"src": "1087:17:5"
								}
							]
						},
						"documentation": null,
						"id": 753,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackTail",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 736,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 735,
									"name": "_secrect",
									"nodeType": "VariableDeclaration",
									"scope": 753,
									"src": "1001:14:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes_memory_ptr",
										"typeString": "bytes"
									},
									"typeName": {
										"id": 734,
										"name": "bytes",
										"nodeType": "ElementaryTypeName",
										"src": "1001:5:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_storage_ptr",
											"typeString": "bytes"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1000:16:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 737,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1024:0:5"
						},
						"scope": 777,
						"src": "981:128:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 775,
							"nodeType": "Block",
							"src": "1155:113:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 760,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 757,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1169:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 758,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1169:9:5",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "302e3432",
													"id": 759,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1182:10:5",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_420000000000000000_by_1",
														"typeString": "int_const 420000000000000000"
													},
													"value": "0.42"
												},
												"src": "1169:23:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 756,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1161:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 761,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1161:32:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 762,
									"nodeType": "ExpressionStatement",
									"src": "1161:32:5"
								},
								{
									"assignments": [
										764
									],
									"declarations": [
										{
											"constant": false,
											"id": 764,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 776,
											"src": "1200:11:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 763,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "1200:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 766,
									"initialValue": {
										"argumentTypes": null,
										"id": 765,
										"name": "owner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 619,
										"src": "1214:5:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1200:19:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 769,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 767,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 619,
											"src": "1225:5:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 768,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "1233:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1225:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 770,
									"nodeType": "ExpressionStatement",
									"src": "1225:17:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 773,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 771,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "1248:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 772,
											"name": "tmp",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 764,
											"src": "1260:3:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1248:15:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 774,
									"nodeType": "ExpressionStatement",
									"src": "1248:15:5"
								}
							]
						},
						"documentation": null,
						"id": 776,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "changeDragonDen",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 754,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1137:2:5"
						},
						"payable": true,
						"returnParameters": {
							"id": 755,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1155:0:5"
						},
						"scope": 777,
						"src": "1113:155:5",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 778,
				"src": "26:1245:5"
			}
		],
		"src": "0:1272:5"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Dragon.sol",
		"exportedSymbols": {
			"Dragon": [
				777
			]
		},
		"id": 778,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 609,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:5"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 777,
				"linearizedBaseContracts": [
					777
				],
				"name": "Dragon",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 611,
						"name": "dragonTail",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "46:22:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 610,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "46:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 613,
						"name": "dragonWings",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "72:23:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 612,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "72:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 615,
						"name": "dragonHead",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "99:22:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 614,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "99:4:5",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 617,
						"name": "dragonDen",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "125:24:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 616,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "125:7:5",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 619,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 777,
						"src": "153:20:5",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 618,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "153:7:5",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 646,
							"nodeType": "Block",
							"src": "226:126:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 628,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 626,
											"name": "dragonTail",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 611,
											"src": "232:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 627,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "245:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "232:18:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 629,
									"nodeType": "ExpressionStatement",
									"src": "232:18:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 632,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 630,
											"name": "dragonWings",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 613,
											"src": "256:11:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 631,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "270:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "256:19:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 633,
									"nodeType": "ExpressionStatement",
									"src": "256:19:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 636,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 634,
											"name": "dragonHead",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 615,
											"src": "281:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 635,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "294:5:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "281:18:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 637,
									"nodeType": "ExpressionStatement",
									"src": "281:18:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 640,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 638,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 619,
											"src": "305:5:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 639,
											"name": "_owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 621,
											"src": "313:6:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "305:14:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 641,
									"nodeType": "ExpressionStatement",
									"src": "305:14:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 644,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 642,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "325:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 643,
											"name": "_dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 623,
											"src": "337:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "325:22:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 645,
									"nodeType": "ExpressionStatement",
									"src": "325:22:5"
								}
							]
						},
						"documentation": null,
						"id": 647,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 624,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 621,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 647,
									"src": "190:14:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 620,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "190:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 623,
									"name": "_dragonDen",
									"nodeType": "VariableDeclaration",
									"scope": 647,
									"src": "206:18:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 622,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "206:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "189:36:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 625,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "226:0:5"
						},
						"scope": 777,
						"src": "178:174:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 659,
							"nodeType": "Block",
							"src": "398:59:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"components": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 656,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 654,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 652,
														"name": "dragonTail",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 611,
														"src": "412:10:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 653,
														"name": "dragonWings",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 613,
														"src": "426:11:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "412:25:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "&&",
												"rightExpression": {
													"argumentTypes": null,
													"id": 655,
													"name": "dragonHead",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 615,
													"src": "441:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "412:39:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"id": 657,
										"isConstant": false,
										"isInlineArray": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "TupleExpression",
										"src": "411:41:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 651,
									"id": 658,
									"nodeType": "Return",
									"src": "404:48:5"
								}
							]
						},
						"documentation": null,
						"id": 660,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "complete",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 648,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "373:2:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 651,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 650,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 660,
									"src": "392:4:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 649,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "392:4:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "391:6:5"
						},
						"scope": 777,
						"src": "356:101:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 674,
							"nodeType": "Block",
							"src": "490:63:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 667,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 664,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "504:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 665,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "504:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 666,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 619,
													"src": "518:5:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "504:19:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 663,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "496:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 668,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "496:28:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 669,
									"nodeType": "ExpressionStatement",
									"src": "496:28:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 672,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 670,
											"name": "dragonHead",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 615,
											"src": "531:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 671,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "544:4:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "531:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 673,
									"nodeType": "ExpressionStatement",
									"src": "531:17:5"
								}
							]
						},
						"documentation": null,
						"id": 675,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackHead",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 661,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "480:2:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 662,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "490:0:5"
						},
						"scope": 777,
						"src": "461:92:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 732,
							"nodeType": "Block",
							"src": "603:374:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 684,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 681,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "617:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 682,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "617:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 683,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 677,
													"src": "631:8:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "617:22:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 680,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "609:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 685,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "609:31:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 686,
									"nodeType": "ExpressionStatement",
									"src": "609:31:5"
								},
								{
									"assignments": [
										688
									],
									"declarations": [
										{
											"constant": false,
											"id": 688,
											"name": "addr",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "647:12:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 687,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "647:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 692,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 690,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 677,
												"src": "670:8:5",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 689,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "662:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes20_$",
												"typeString": "type(bytes20)"
											},
											"typeName": "bytes20"
										},
										"id": 691,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "662:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes20",
											"typeString": "bytes20"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "647:32:5"
								},
								{
									"assignments": [
										694
									],
									"declarations": [
										{
											"constant": false,
											"id": 694,
											"name": "ftBlood",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "685:15:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 693,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "685:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 696,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "00000000000000000000000000000000042b100d",
										"id": 695,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "703:45:5",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_182bb3fec0beccb0a6ed9760bb9b85e822212cadb96c14aa54c4df47cb8d9bf6",
											"typeString": "literal_string \"\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0004+\u0010\r\""
										},
										"value": "\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0004+\u0010\r"
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "685:63:5"
								},
								{
									"assignments": [
										698
									],
									"declarations": [
										{
											"constant": false,
											"id": 698,
											"name": "mask",
											"nodeType": "VariableDeclaration",
											"scope": 733,
											"src": "754:12:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes20",
												"typeString": "bytes20"
											},
											"typeName": {
												"id": 697,
												"name": "bytes20",
												"nodeType": "ElementaryTypeName",
												"src": "754:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes20",
													"typeString": "bytes20"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 700,
									"initialValue": {
										"argumentTypes": null,
										"hexValue": "000000000000000000000000000000000fffffff",
										"id": 699,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "769:45:5",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_04be31e00e47e621a6f132c63a563fa1b96fc809d569bf050c86d8cff4f8101f",
											"typeString": "literal_string (contains invalid UTF-8 sequence at position 17)"
										},
										"value": null
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "754:60:5"
								},
								{
									"body": {
										"id": 730,
										"nodeType": "Block",
										"src": "854:118:5",
										"statements": [
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													},
													"id": 715,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														},
														"id": 713,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 711,
															"name": "addr",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 688,
															"src": "866:4:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes20",
																"typeString": "bytes20"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 712,
															"name": "mask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 698,
															"src": "873:4:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes20",
																"typeString": "bytes20"
															}
														},
														"src": "866:11:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 714,
														"name": "ftBlood",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 694,
														"src": "881:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"src": "866:22:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 721,
												"nodeType": "IfStatement",
												"src": "862:65:5",
												"trueBody": {
													"id": 720,
													"nodeType": "Block",
													"src": "890:37:5",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 718,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 716,
																	"name": "dragonWings",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 613,
																	"src": "900:11:5",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "74727565",
																	"id": 717,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "914:4:5",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "true"
																},
																"src": "900:18:5",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 719,
															"nodeType": "ExpressionStatement",
															"src": "900:18:5"
														}
													]
												}
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 724,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 722,
														"name": "mask",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 698,
														"src": "934:4:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "Assignment",
													"operator": "<<=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "34",
														"id": 723,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "943:1:5",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_4_by_1",
															"typeString": "int_const 4"
														},
														"value": "4"
													},
													"src": "934:10:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													}
												},
												"id": 725,
												"nodeType": "ExpressionStatement",
												"src": "934:10:5"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 728,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 726,
														"name": "ftBlood",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 694,
														"src": "952:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes20",
															"typeString": "bytes20"
														}
													},
													"nodeType": "Assignment",
													"operator": "<<=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "34",
														"id": 727,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "964:1:5",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_4_by_1",
															"typeString": "int_const 4"
														},
														"value": "4"
													},
													"src": "952:13:5",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes20",
														"typeString": "bytes20"
													}
												},
												"id": 729,
												"nodeType": "ExpressionStatement",
												"src": "952:13:5"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 705,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 702,
											"src": "841:1:5",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "3334",
											"id": 706,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "845:2:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_34_by_1",
												"typeString": "int_const 34"
											},
											"value": "34"
										},
										"src": "841:6:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 731,
									"initializationExpression": {
										"assignments": [
											702
										],
										"declarations": [
											{
												"constant": false,
												"id": 702,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 733,
												"src": "826:9:5",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 701,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "826:7:5",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 704,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 703,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "838:1:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "826:13:5"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 709,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "849:3:5",
											"subExpression": {
												"argumentTypes": null,
												"id": 708,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 702,
												"src": "849:1:5",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 710,
										"nodeType": "ExpressionStatement",
										"src": "849:3:5"
									},
									"nodeType": "ForStatement",
									"src": "821:151:5"
								}
							]
						},
						"documentation": null,
						"id": 733,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackWings",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 678,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 677,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 733,
									"src": "578:16:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 676,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "578:7:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "577:18:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 679,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "603:0:5"
						},
						"scope": 777,
						"src": "557:420:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 752,
							"nodeType": "Block",
							"src": "1024:85:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 745,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 741,
																	"name": "_secrect",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 735,
																	"src": "1056:8:5",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes_memory_ptr",
																		"typeString": "bytes memory"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes_memory_ptr",
																		"typeString": "bytes memory"
																	}
																],
																"id": 740,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "1046:9:5",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 742,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "1046:19:5",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 739,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "1038:7:5",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 743,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1038:28:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 744,
													"name": "dragonDen",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 617,
													"src": "1070:9:5",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1038:41:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 738,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1030:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 746,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1030:50:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 747,
									"nodeType": "ExpressionStatement",
									"src": "1030:50:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 750,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 748,
											"name": "dragonTail",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 611,
											"src": "1087:10:5",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 749,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1100:4:5",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "1087:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 751,
									"nodeType": "ExpressionStatement",
									"src": "1087:17:5"
								}
							]
						},
						"documentation": null,
						"id": 753,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "attackTail",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 736,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 735,
									"name": "_secrect",
									"nodeType": "VariableDeclaration",
									"scope": 753,
									"src": "1001:14:5",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes_memory_ptr",
										"typeString": "bytes"
									},
									"typeName": {
										"id": 734,
										"name": "bytes",
										"nodeType": "ElementaryTypeName",
										"src": "1001:5:5",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_storage_ptr",
											"typeString": "bytes"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1000:16:5"
						},
						"payable": false,
						"returnParameters": {
							"id": 737,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1024:0:5"
						},
						"scope": 777,
						"src": "981:128:5",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 775,
							"nodeType": "Block",
							"src": "1155:113:5",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 760,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 757,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "1169:3:5",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 758,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1169:9:5",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "302e3432",
													"id": 759,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1182:10:5",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_420000000000000000_by_1",
														"typeString": "int_const 420000000000000000"
													},
													"value": "0.42"
												},
												"src": "1169:23:5",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 756,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1161:7:5",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 761,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1161:32:5",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 762,
									"nodeType": "ExpressionStatement",
									"src": "1161:32:5"
								},
								{
									"assignments": [
										764
									],
									"declarations": [
										{
											"constant": false,
											"id": 764,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 776,
											"src": "1200:11:5",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"typeName": {
												"id": 763,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "1200:7:5",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 766,
									"initialValue": {
										"argumentTypes": null,
										"id": 765,
										"name": "owner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 619,
										"src": "1214:5:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1200:19:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 769,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 767,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 619,
											"src": "1225:5:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 768,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "1233:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1225:17:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 770,
									"nodeType": "ExpressionStatement",
									"src": "1225:17:5"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 773,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 771,
											"name": "dragonDen",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 617,
											"src": "1248:9:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 772,
											"name": "tmp",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 764,
											"src": "1260:3:5",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1248:15:5",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 774,
									"nodeType": "ExpressionStatement",
									"src": "1248:15:5"
								}
							]
						},
						"documentation": null,
						"id": 776,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "changeDragonDen",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 754,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1137:2:5"
						},
						"payable": true,
						"returnParameters": {
							"id": 755,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1155:0:5"
						},
						"scope": 777,
						"src": "1113:155:5",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 778,
				"src": "26:1245:5"
			}
		],
		"src": "0:1272:5"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.797Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Dragon.json
// module id = 1030
// module chunks = 0